<template>
  <div class="insurance-companies-page">
    <InsuranceCompanies />
  </div>
</template>

<script>
import { InsuranceCompanies } from '@/features/promo';

export default {
  components: { InsuranceCompanies },
};
</script>

<style lang="scss" scoped>
.insurance-companies-page {
  overflow: hidden;
}
</style>
